var trigger;
var callbacks = [];
var notify = function () { return callbacks.splice(0).forEach(function (cb) { return cb(); }); };
var queueMicroTask = function (callback) {
    // Create on request for SSR
    // ToDo: Look at changing this
    if (!trigger) {
        var el_1 = document.createTextNode('');
        var config = { characterData: true };
        new MutationObserver(function () { return notify(); }).observe(el_1, config);
        trigger = function () { el_1.textContent = ''; };
    }
    callbacks.push(callback);
    trigger();
};
export { queueMicroTask };
